import {
    REGISTER_REQUEST,
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    USER_LOADED_REQUEST,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    AUTH_ERROR,
  } from '../constants/authConstants';
  
  // Reducer to handle user loading
  export const userLoadedReducer = (state = { user: null, loading: false, isAuthenticated: false }, action) => {
    switch (action.type) {
      case USER_LOADED_REQUEST:
        return { ...state, loading: true };
      case USER_LOADED_SUCCESS:
        return { ...state, loading: false, user: action.payload, isAuthenticated: true };
      case USER_LOADED_FAIL:
        return { ...state, loading: false, error: action.payload, isAuthenticated: false };
      case LOGIN_REQUEST:
        return { ...state, loading: true };
      case LOGIN_SUCCESS:
        return { ...state, loading: false, isAuthenticated: true };
      case LOGIN_FAIL:
        return { ...state, loading: false, error: action.payload, isAuthenticated: false };
      case LOGOUT:
        return { ...state, loading: false, user: null, isAuthenticated: false };
      default:
        return state;
    }
  };
  
  // Reducer to handle user registration
  export const userRegisterReducer = (state = {}, action) => {
    switch (action.type) {
      case REGISTER_REQUEST:
        return { loading: true };
      case REGISTER_SUCCESS:
        // localStorage.setItem('token', action.payload.token);
        return { loading: false, success: true, token: action.payload.token };
      case REGISTER_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Reducer to handle user login
  export const userLoginReducer = (state = {}, action) => {
    switch (action.type) {
      case LOGIN_REQUEST:
        return { loading: true };
      case LOGIN_SUCCESS:
        localStorage.setItem('token', action.payload.token);
        return { loading: false, success: true, token: action.payload.token };
      case LOGIN_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Reducer to handle user logout
  export const userLogoutReducer = (state = {}, action) => {
    switch (action.type) {
      case LOGOUT:
        return {
          ...state,
          isAuthenticated: false,
          user: null,
        };
      default:
        return state;
    }
  };
  
  // Reducer to handle authentication errors
  export const authErrorReducer = (state = {}, action) => {
    switch (action.type) {
      case AUTH_ERROR:
        localStorage.removeItem('token');
        return { error: action.payload };
      default:
        return state;
    }
  };